<template>
  <div
    class="row"
    :data-testid="`member-hris-details-${hrisDetail.integration_type}`"
  >
    <div class="col-sm-6">
      <div class="d-flex justify-content-between align-items-center my-20">
        <h6
          class="m-0"
          :data-testid="`member-hris-details-title-${hrisDetail.integration_type}`"
        >
          {{ sectionTitle }}
        </h6>
        <a
          v-if="externalUrl"
          :data-testid="`member-hris-details-link-${hrisDetail.integration_type}`"
          :href="externalUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="strong text-default-size no-wrap"
        >
          {{ openInProviderLabel }}
        </a>
      </div>
      <div class="form-group">
        <label class="control-label">Reports to</label>
        <AppInput
          :data-test-id="`member-hris-reports-to-${hrisDetail.integration_type}`"
          :value="reportsTo"
          readonly
          placeholder="No reports to"
        />
      </div>
      <div class="form-group">
        <label class="control-label">Department</label>
        <AppInput
          :data-test-id="`member-hris-department-${hrisDetail.integration_type}`"
          :value="department"
          readonly
          placeholder="No department"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from '~/components/AppInput.vue';

export default {
  name: 'MemberHrisDetails',
  components: { AppInput },
  props: {
    hrisDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionTitle() {
      return `${this.hrisDetail.provider_name} details`;
    },
    openInProviderLabel() {
      return `Open in ${this.hrisDetail.provider_name}`;
    },
    department() {
      return this.hrisDetail.department || '';
    },
    reportsTo() {
      return this.hrisDetail.reports_to || '';
    },
    externalUrl() {
      return this.hrisDetail.url || '';
    },
  },
};
</script>
